export default "__VITE_ASSET__27b582b5__"